module.exports = __webpack_public_path__ + "img/IMG_5119.9239a7b5.jpg";